import type { MonthlyNthApi } from "../../../services/distributions/distributions.types";

/** Days 1–28 exist in every month; later days are offered as "Last day". */
export const MONTH_DAY_OPTIONS: { value: string; label: string }[] = [
  ...Array.from({ length: 28 }, (_, index) => ({ value: String(index + 1), label: `Day ${index + 1}` })),
  { value: "last", label: "Last day" },
];

export const NTH_OPTIONS: { value: string; label: string }[] = [
  { value: "1", label: "First" },
  { value: "2", label: "Second" },
  { value: "3", label: "Third" },
  { value: "4", label: "Fourth" },
  { value: "last", label: "Last" },
];

/** Contract numbering: 0 = Monday … 6 = Sunday. */
export const WEEKDAY_OPTIONS: { value: string; label: string }[] = [
  "Monday",
  "Tuesday",
  "Wednesday",
  "Thursday",
  "Friday",
  "Saturday",
  "Sunday",
].map((label, index) => ({ value: String(index), label }));

export const BUSINESS_NTH_OPTIONS: { value: string; label: string }[] = [
  { value: "1", label: "First" },
  { value: "last", label: "Last" },
];

export const parseMonthDay = (value: string): number | "last" => {
  if (value === "last") return "last";
  const day = Math.floor(Number(value));
  return Number.isFinite(day) ? Math.min(28, Math.max(1, day)) : 1;
};

export const parseNth = (value: string): MonthlyNthApi => {
  if (value === "last") return "last";
  const nth = Math.floor(Number(value));
  return nth === 2 || nth === 3 || nth === 4 ? nth : 1;
};

export const parseWeekday = (value: string): number => {
  const weekday = Math.floor(Number(value));
  return Number.isFinite(weekday) && weekday >= 0 && weekday <= 6 ? weekday : 0;
};

export const parseBusinessNth = (value: string): 1 | "last" => (value === "last" ? "last" : 1);

/** The inline appearance's rule-mode select. */
export const RULE_MODE_OPTIONS: { value: string; label: string }[] = [
  { value: "day", label: "Day" },
  { value: "weekday", label: "Weekday" },
  { value: "business_day", label: "Business day" },
];
